module.exports = __webpack_public_path__ + "img/1920x700-2.aa0835a6.jpg";